import React from 'react'
import { fetchBrandInactiveReason } from './getBrandsInactiveReasonOptions'
import { isBrandArchived } from './splitBrandsByArchive'
import styles from './BrandsPanel.module.scss'

const ARCHIVED_BRAND_STATUS = {
  label: 'В архіві',
  markColor: 'var(--darkGray)',
}

const getBrandStatusLine = (brand, showInactiveReason) => {
  if (isBrandArchived(brand)) {
    return ARCHIVED_BRAND_STATUS
  }

  if (brand.slugNeedsReview === true) {
    return {
      label: 'Перевірити slug',
      markColor: 'var(--accent)',
    }
  }

  if (showInactiveReason && brand.isActive !== true) {
    const inactiveReason = fetchBrandInactiveReason(brand.inactiveReason)

    if (inactiveReason.label) {
      return inactiveReason
    }
  }

  return null
}

function BrandListItem({
  brand,
  activeId,
  onClick,
  showInactiveReason,
  showProductsCount,
  isHiddenItem = false,
  dragHandle = null,
}) {
  const isDisabled = brand.isActive === false
  const statusLine = getBrandStatusLine(brand, showInactiveReason)
  const brandClassName = [
    styles.brand,
    `${activeId}` === `${brand.id}` ? styles.brandActive : '',
    isDisabled ? styles.brandDetached : '',
    isHiddenItem ? styles.brandArchived : '',
    dragHandle ? styles.brandReorderable : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div key={brand.id} className={brandClassName} onClick={() => onClick(brand.id)}>
      {dragHandle}
      <div className={styles.brandBody}>
        <p className={styles.title}>{brand.name}</p>
        {showProductsCount && <p className={styles.meta}>{brand.productsCount || 0} товарів</p>}
        {statusLine && (
          <p className={styles.reason}>
            <span className={styles.mark} style={{ background: statusLine.markColor }}></span>
            {statusLine.label}
          </p>
        )}
      </div>
    </div>
  )
}

export default BrandListItem
